import { apiClient, APIResponse } from './client';
import { Component } from './components';
import { FindProjectsOptions, Project } from './projects';


export interface DashboardFilterOptions {
  workgroupId?: number;
  applicationIds?: number[];
}

export interface DashboardMetrics {
  totalApplications: number;
  totalProjects: number;
  totalScans: number;
  activeScans: number;
  totalVulnerabilities: number;
  criticalVulnerabilities: number;
  totalComponents: number;
  lastScanDate: string;
}

export interface VulnerabilityDistribution {
  critical: number;
  high: number;
  medium: number;
  low: number;
}

export interface LicenseDistribution {
  critical: number;
  high: number;
  medium: number;
  low: number;
  permissive: number;
  copyleft: number;
  proprietary: number;
}

export interface SecurityScoreTrend {
  date: string;
  overallScore: number;
  vulnerabilityScore: number;
  licenseScore: number;
  technicalDebtScore: number;
}

export interface ApplicationRiskHeatmap {
  name: string;
  value: number;
  riskLevel: 'Low' | 'Medium' | 'High' | 'Critical';
  description: string;
  componentCount: number;
  projectName: string;
}

export interface RiskImpactMatrix {
  applicationName: string;
  riskScore: number;
  businessImpact: number;
  componentCount: number;
  vulnerabilityCount: number;
}

export interface TechnicalDebtCorrelation {
  applicationName: string;
  technicalDebtScore: number;
  businessImpactScore: number;
  resourceAllocationScore: number;
  projectSize: number;
}

export interface RecentActivity {
  id: number;
  type: 'scan_completed' | 'vulnerability_found' | 'license_issue' | 'scan_failed';
  message: string;
  applicationName: string;
  projectName: string;
  timestamp: string;
  severity?: 'Critical' | 'High' | 'Medium' | 'Low';
}

export interface TopVulnerability {
  cve: string;
  description: string;
  severity: 'Critical' | 'High' | 'Medium' | 'Low';
  score: number;
  affectedApplications: number;
  affectedComponents: number;
  firstDetected: string;
  exploitable: boolean;
}

export interface TopApplicationRisk {
  applicationId: number;
  applicationName: string;
  riskScore: number;
  businessImpact: 'Critical' | 'High' | 'Medium' | 'Low';
  vulnerabilityCount: number;
  licenseIssueCount: number;
  lastScanDate: string;
  projectCount: number;
}

export interface DashboardScores {
  overallScore: number;
  licenseScore: number;
  vulnerabilityScore: number;
  operationalScore: number;
  technicalDebtScore: number;
}

export class DashboardAPI {

  static async getAllProjects(options?: FindProjectsOptions): Promise<APIResponse<Project[]>> {
    return apiClient.get<Project[]>('/dashboard/projects', options);
  }
  static async getAllComponents(options?: FindProjectsOptions): Promise<APIResponse<Component[]>> {
    return apiClient.get<Component[]>('/dashboard/components', options);
  }
  static async getScores(options?: DashboardFilterOptions): Promise<APIResponse<DashboardScores>> {
    return apiClient.get<DashboardScores>('/dashboard/scores', options);
  }

}
